import React from "react";
import "react-datepicker/dist/react-datepicker.css";
 
const Dashboard: React.FC = () => {
  return (
    <>
      <div className="content">
        <div className="container-xl">
          <div className="page-header">
            <div className="row">
              <h2 className="col-auto page-title">Home</h2>
            </div>
          </div>
          <div className="row">
            <div className="card p-5">
              <div className="card-body">
                <div className="text-center">
                  <h3 className="m-0 mb-1">
                    Seja bem-vindo ao MOF - Mídia Oficial do Fornecedor.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
 
export default Dashboard;